import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  DateField,
  useShowController,
  useListContext,
  useRedirect
} from 'react-admin';
import { Chip, Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import TimerIcon from '@mui/icons-material/Timer';

import EmptyState from '../EmptyState';
import { formatDuration } from '../../utils/timeFormat';
import useStyles from './styles';

const StatusField = ({ record }) => {
  const classes = useStyles();
  const percent = record.percentWatched || 0;
  if (percent <= 0) return null;

  let chipClass;
  let statusText;
  let icon;
  if (percent >= 100) {
    chipClass = classes.completedStatus;
    statusText = 'Дууссан';
    icon = <CheckCircleIcon fontSize="small" />;
  } else {
    chipClass = classes.inProgressStatus;
    statusText = 'Үргэлжилж байгаа';
    icon = <HourglassEmptyIcon fontSize="small" />;
  }

  return (
    <Tooltip title={`${percent}%`}>
      <Chip
        icon={icon}
        label={statusText}
        size="small"
        className={chipClass}
      />
    </Tooltip>
  );
};

const DurationDisplay = ({ record }) => {
  const classes = useStyles();
  if (!record.watchedDuration || ['not_started', 'notstarted'].includes(record.status?.toLowerCase())) {
    return '-';
  }
  return (
    <Chip
      icon={<TimerIcon fontSize="small" />}
      label={formatDuration(record.watchedDuration)}
      size="small"
      className={classes.durationChip}
    />
  );
};

const FilteredVideoDatagrid = ({ classes, userId }) => {
  const { ids, data, loaded } = useListContext();
  const redirect = useRedirect();

  // Function to create a rowClick handler for watchHistory
  const handleRowClick = () => {
    const filter = JSON.stringify({ userId });
    redirect(`/watchHistory?filter=${encodeURIComponent(filter)}`);
  };

  if (!loaded) return null;

  const filteredIds = ids.filter(id => data[id].percentWatched > 0);
  if (filteredIds.length === 0) {
    return <EmptyState message="Видео үзэлт түүх байхгүй байна" />;
  }

  return (
    <Datagrid
      ids={filteredIds}
      data={data}
      rowClick={handleRowClick}
      className={classes.watchHistoryTable}
      size="small"
      bulkActionButtons={false}
    >
      <TextField source="courseTitle" label="Сургалт" />
      <TextField source="courseSectionTitle" label="Хэсэг" />
      <FunctionField label="Үзсэн хугацаа" render={record => <DurationDisplay record={record} />} />
      <FunctionField label="Нийт хугацаа" render={record => record.totalDuration ? formatDuration(record.totalDuration) : '-'} />
      <FunctionField label="Харсан хувь" render={record => record.percentWatched != null ? `${record.percentWatched}%` : '-'} />
      <FunctionField label="Төлөв" render={record => <StatusField record={record} />} />
      <DateField source="startedAt" label="Эхэлсэн" showTime />
      <DateField source="completedAt" label="Дууссан" showTime />
    </Datagrid>
  );
};

const VideoHistoryTab = props => {
  const { record, basePath } = useShowController(props);
  const classes = useStyles();
  if (!record) return null;

  return (
    <List
      hasCreate={false}
      hasEdit={false}
      hasShow={false}
      hasList={false}
      resource="watchHistory"
      basePath={basePath}
      filter={{ userId: record.id }}
      perPage={25}
      pagination={false}
      bulkActionButtons={false}
      sort={{ field: 'startedAt', order: 'DESC' }}
      empty={<EmptyState message="Видео үзэлт түүх байхгүй байна" />}
      actions={false}
      exporter={false}
    >
      <FilteredVideoDatagrid classes={classes} userId={record.id} />
    </List>
  );
};

export default VideoHistoryTab; 